import React, { useState, useEffect, useCallback, useContext } from 'react'
import '../css/sb-admin-2.min.css'
import '../css/sb-admin-2.css'
import DatePicker, { CalendarContainer } from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { AppColors } from '../css/AppColors';
import { Modal, Button, Form } from 'react-bootstrap';
import { apiRequest } from '../utils/apiCalls';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import { Context } from '../Context/DataContext';
import { useHistory, useLocation } from 'react-router';
import { getStoreData, getStoreDataFromLocal } from '../utils/functions';
// import { reactLocalStorage } from 'reactjs-localstorage';



const useForceUpdate = () => {
    const [, updateState] = React.useState();
    return useCallback(() => updateState({}), []);
}



const AddProdExpiry = () => {

    const location = useLocation();
    const forceUpdate = useForceUpdate()
    const history = useHistory();
    const [startDate, setStartDate] = useState(new Date());

    const { state, setStoreData, setProductsGlobal } = useContext(Context)
    const [parents, setParents] = useState([]);


    const [prod, setProd] = useState(state.products ? state.products : []);

    const [loading, setLoading] = useState(false)

    const [expiryData, setExpiryData] = useState({
        exp_title: '',
        exp_no_days: '',
        status: '1',
        parent: '',
        st_id: state.storeData.st_id

    })


    function getParents() {
        setLoading(true)
        apiRequest({ st_id: state.storeData.st_id }, 'getExpiriesParent')
            .then(data => {
                console.log(data)
                setLoading(false)
                if (data.data) {
                    setParents(data.data)
                }

            })
            .catch(err => setLoading(false))
    }

    useEffect(() => {
        getParents()
    }, [])

    function addExpiry() {

        if (expiryData.exp_title == '') {
            alert('Please enter a age title')
            return
        }
        if (expiryData.parent == '') {
            alert('Please enter a ge parent')
            return
        }

        setLoading(true)
        apiRequest(expiryData, 'addExpiry')
            .then(data => {
                console.log(data)
                setLoading(false)
                if (data.status == 1) {
                    // alert('Customer Added')
                    history.replace('/viewExpiries')
                }
                else {
                    alert(data.error)
                }
            })
            .catch(err => {
                setLoading(false)
                // console.log(err)
                alert('Internet Error')
            })



    }










    return (
        <div id="page-top">
            <div id="wrapper" >
                <Sidebar />
                <div id="content-wrapper" class="d-flex flex-column">
                    <div id="content">
                        <Topbar />


                        <div className="container-fluid" >


                            <Modal
                                show={loading}
                                onHide={() => setLoading(false)}
                            >

                                <Modal.Body class="text-center" >
                                    <div
                                        class="text-center"
                                        class="spinner-border text-center" style={{ margin: 10, color: AppColors.primary }} role="status"></div>
                                </Modal.Body>

                            </Modal>
                            {/* Page Wrapper */}
                            <div id="wrapper" >
                                {/* Content Wrapper */}
                                <div id="content-wrapper" className="d-flex flex-column" style={{ paddingBottom: 200 }} >
                                    {/* Main Content */}
                                    <div id="content">
                                        {/* Begin Page Content */}
                                        <div className="container-fluid">
                                            {/* Page Heading */}
                                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                                <h1 className="h3 mb-0 text-gray-800">Add Product Age</h1>
                                            </div>
                                            <div className="form-group row">

                                                <div className="col-sm-6 mb-3 mb-sm-0">
                                                    <div className="editDetails" >Parent</div>
                                                    <select
                                                        className="form-control form-control-user"
                                                        placeholder="Best Contact"
                                                        onChange={(t) => {

                                                            // if (t.target.value == '0') {
                                                            setExpiryData({
                                                                ...expiryData,
                                                                parent: t.target.value
                                                            })
                                                            // }


                                                        }}

                                                    >
                                                        <option selected disabled>
                                                            {"Select"}
                                                        </option>
                                                        <option value={"0"} >
                                                            {"No Parent"}
                                                        </option>
                                                        {
                                                            parents.map((v) => {
                                                                return (
                                                                    <>
                                                                        <option value={v.exp_id}>{v.exp_title}</option>
                                                                    </>

                                                                )
                                                            })
                                                        }

                                                    </select>
                                                    <br />
                                                </div>
                                                <br />



                                                <div className="col-sm-6">
                                                    <div className="editDetails" >Age Title</div>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-user"
                                                        onChange={(t) => {
                                                            setExpiryData({
                                                                ...expiryData,
                                                                exp_title: t.target.value
                                                            })
                                                        }}

                                                    />
                                                    <br />
                                                </div>
                                                <div className="col-sm-6 mb-3 mb-sm-0">
                                                    <div className="editDetails" >Notification (days)</div>
                                                    <input
                                                        type={"number"}
                                                        min={1}
                                                        disabled={parents.length ? false : true}
                                                        className="form-control form-control-user"
                                                        onChange={(t) => {
                                                            setExpiryData({
                                                                ...expiryData,
                                                                exp_no_days: t.target.value
                                                            })
                                                        }}
                                                    />
                                                    <br />
                                                </div>




                                                <div className="col-sm-6 mb-3 mb-sm-0">
                                                    <div className="editDetails" >Status</div>
                                                    <select
                                                        className="form-control form-control-user"
                                                        placeholder="Best Contact"
                                                        onChange={(t) => {
                                                            setExpiryData({
                                                                ...expiryData,
                                                                status: t.target.value
                                                            })
                                                        }}

                                                    >
                                                        {/* <option selected disabled>
                                                            Select
                                                        </option> */}
                                                        <option selected value={1}>Active</option>
                                                        <option value={0}>Inactive</option>

                                                    </select>
                                                    <br />
                                                </div>

                                                <Button
                                                    id="add_customer"
                                                    className="btn btn-primary btn-user btn-block rBBtn"
                                                    onClick={() => addExpiry()}
                                                    style={{ backgroundColor: AppColors.primary, borderWidth: 0, fontFamily: 'RBo' }}
                                                >
                                                    Add
                                                </Button>
                                                {/* </form> */}
                                            </div>

                                            {/* /.container-fluid */}
                                        </div>
                                        {/* End of Main Content */}
                                    </div>
                                    {/* End of Content Wrapper */}
                                </div>
                                {/* End of Page Wrapper */}
                                {/* Scroll to Top Button*/}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default AddProdExpiry
